import styled from "styled-components";

export const DropdownWrapper = styled.div`
  width: calc(100% - 50px);
  position: relative;
  box-shadow: 1px 1px 6px #d7d7d7;
  margin-bottom: 20px;
  margin-right: 10px;

  & input:disabled {
    background-color: white;
  }
`;

export const DropdownOption = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background-color: #e1e1e1;
  }

  & svg {
    color: rgb(6, 172, 56);
  }
`;

export const DropdownInput = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & svg {
    color: rgb(6, 172, 56);
  }
`;

export const DropdownOptions = styled.div`
  position: absolute;
  width: 100%;
  background-color: white;
  border: 1px solid #d7d7d7;
  z-index: 4;
  max-height: 500px;
  overflow-y: auto;
`;

export const DropdownContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row-reverse;

  & input {
    margin: 0px;
    outline: none;
    width: calc(100% - 65px);
    height: 100%;
    padding: 15px;
    border: none;
    text-align: center;
    border-radius: 1px;
    border: 1px solid #d7d7d7;
    border-bottom-right-radius: 0px;
    border-top-right-radius: 0px;
    font-weight: bold;
    font-size: 14px;
    text-transform: uppercase;
  }
`;

export const DropdownChevron = styled.div`
  height: 46px;
  width: 32px;
  justify-content: center;
  align-items: center;
  display: flex;
  border: 1px solid #d7d7d7;
  color: black;
  border-bottom-right-radius: 2px;
  border-top-right-radius: 2px;
  background-color: white;
`;
